export function getSpaceVariable(scale: number) {
    return `var(--rs-unit-x${scale})`;
}
